import { render, staticRenderFns } from "./sportsDetails.vue?vue&type=template&id=a1e507f4&scoped=true&"
import script from "./sportsDetails.vue?vue&type=script&lang=js&"
export * from "./sportsDetails.vue?vue&type=script&lang=js&"
import style0 from "./sportsDetails.vue?vue&type=style&index=0&id=a1e507f4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e507f4",
  null
  
)

export default component.exports